import React, { FC, useContext } from "react";
import { defineMessages, useIntl } from "react-intl";

import {
  BillingPaymentPlanCard,
  BillingHistoryTemplate,
} from "@app/postBill/components/billingCenterHistory";
import { PostBillHistoryContext } from "@app/provider";
import { PaymentPlanCardItem } from "@app/postBill/models";

const messages = defineMessages({
  billingHistoryPaymentPlansTitle: {
    id: "billingHistoryPaymentPlansTitle",
    defaultMessage: "Payment Plans",
  },
});

const BillingHistoryPaymentPlans: FC = () => {
  const intl = useIntl();
  const {
    loadPaymentPlansHistory,
    loadPaymentPlansPage,
    togglePaymentPlansSort,
    testCards,
  } = useContext(PostBillHistoryContext);

  const renderPaymentPlanCards = () => {
    return (
      <>
        {testCards &&
          (testCards as PaymentPlanCardItem[]).map(
            (item: PaymentPlanCardItem) => (
              <BillingPaymentPlanCard
                key={item?.paymentPlanId}
                currency={item?.currency}
                dueDate={item?.dueDate}
                caseNumber={item?.caseNumber}
                remainingBalance={item?.remainingBalance}
                paymentMethod={item?.paymentMethod}
                installmentAmount={item?.installmentAmount}
                numInstallments={item?.numInstallments}
                currentInstallmentIndex={item?.currentInstallmentIndex}
                paymentPlanId={item?.paymentPlanId}
                status={item?.status}
              />
            )
          )}
      </>
    );
  };

  return (
    <BillingHistoryTemplate
      title={intl.formatMessage(messages.billingHistoryPaymentPlansTitle)}
      loadHistory={loadPaymentPlansHistory}
      loadPage={loadPaymentPlansPage}
      toggleSort={togglePaymentPlansSort}
      medium
    >
      {testCards && renderPaymentPlanCards()}
    </BillingHistoryTemplate>
  );
};

export default BillingHistoryPaymentPlans;
